// import "pwa-mmt-ui-header/ssr/header.css";
import React, { useContext, useEffect, useState } from "react";
import PreloadImages from "./PreloadImages";

import {
  DomesticTrip,
  SecureTravOffer,
  TravellingTo,
} from "@insurance/landing-ui/components";
import { ExperimentTrackingString, useBreakpointV2 } from "@tm/ui-widgets";
import {
  DesktopLayout,
  FlexComp,
  FormattedText,
  ImageComponent,
  SpanTag,
} from "@tm/ui-widgets/components";
import { theme } from "@tm/utility/global";

import InsuranceBottomComp from "./InsuranceBottomComp";

import { getAnalytics } from "@tm/insurance/analytics";
import { navigationActionsSeo } from "@tm/insurance/navigation";
import { getCookieByName } from "@tm/insurance/utils";
import { usePartnerContext } from "@tm/ui-widgets/hooks";
import InsuranceLandingShimmer from "./InsuranceLandingShimmer";
import { LandingPageProps } from "./types";

import {
  initializePageTracking,
  trackEvent,
} from "@tm/insurance/analytics/xdm";
import { LandingPageRightWrapper } from "./InsuranceLanding.style";

const analytics = getAnalytics();

const InsuranceLanding = ({ data, setActiveModal }: LandingPageProps) => {
  const context = usePartnerContext();
  const experiment = useContext(ExperimentTrackingString) || "";

  if (!data) return <InsuranceLandingShimmer />;

  const {
    title,
    claimSettlementText,
    secureTravData,
    travellingTo,
    calendarDatesLimit,
    upcomingTrip,
    upcomingTripsV2,
    errorFields,
    footer,
    travelSearchBanner,
    nextPageRoute,
    analytics: pageAnalytics,
  } = data || {};

  const device = useBreakpointV2();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = queryParams.get("countries") || data?.countryCode;

    const selectedCountryCodes = selectedCountries?.split(",");
    let segmentType = queryParams.get("segment");
    if (data?.seoPageType === "SEGMENT" && data?.segmentId) {
      segmentType = data?.segmentId;
    }
    const countryData =
      travellingTo?.travelSearchForm?.regionCountryList?.value || [];

    let totalCountryData = countryData?.map((data: any) => {
      if (selectedCountryCodes?.includes(data.code)) {
        return { ...data, isSelected: true };
      }
      return { ...data };
    });
    const selectedCountry = totalCountryData?.filter(
      (item: any) => item.isSelected
    );

    if (countryData?.length) {
      localStorage.setItem(
        "TRAVEL_INSURANCE_COUNTRIES",
        JSON.stringify(countryData)
      );
    }
    if (data) {
      if (pageAnalytics?.pageLoad) {
        analytics?.trackRawPageLoadEvent(pageAnalytics.pageLoad);
      } else {
        analytics?.trackPageLoadEvent({
          pageName: "LANDING",
          experiment,
        });
      }
      initializePageTracking(
        {
          page_context: {
            page_name: "landing",
            page_type: "landing",
            funnel_step: "landing",
            subpage_name: `seo_landing${
              data?.travelCountry ? `:${data?.travelCountry}` : ""
            }`,
          },
        },
        {
          countries: selectedCountry ? selectedCountry : [],
          journeyType: segmentType || "",
          travellers: parseInt(queryParams.get("travellers") || "1"),
          fromDateTime: queryParams.get("startDate")
            ? parseInt(queryParams.get("startDate") || "0")
            : 0,
          toDateTime: queryParams.get("endDate")
            ? parseInt(queryParams.get("endDate") || "0")
            : 0,
        }
      );
    }
  }, [data]);

  useEffect(() => {
    const authCookie =
      getCookieByName("mmt-auth") || getCookieByName("OAUTH-GOIBIBO");
    setIsLoggedIn(!!authCookie);
  }, []);

  const goToMyOrders = () => {
    analytics?.trackLandingEvents(
      {
        actionType: "my_orders_clicked",
      }
      //"click"
    );

    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "my_orders_clicked",
      },
    });

    const authCookie =
      getCookieByName("mmt-auth") || getCookieByName("OAUTH-GOIBIBO");

    if (authCookie) {
      navigationActionsSeo.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  };

  return (
    <>
      <PreloadImages data={data} />
      <DesktopLayout
        landingPageProp
        title={title}
        height={device == "lg" ? "720px" : ""}
        rightSectionHeight="unset"
        leftSectionHeight
        landingMargin
        goToMyOrders={goToMyOrders}
        showMyOrders={isLoggedIn}
        leftComp={
          <React.Fragment>
            <FlexComp
              margin={device == "sm" ? "0 0 0px" : context ? "-30px 0 0" : ""}
              alignItems="center"
              gap="6px"
            >
              <ImageComponent
                width="12px"
                height="16px"
                src={claimSettlementText?.icon}
                loading="eager"
              />
              <SpanTag fontSize="xs" fontWeight="bold" color={theme.blackText}>
                <FormattedText value={claimSettlementText?.title} />
              </SpanTag>
            </FlexComp>
            {device == "lg" ? <SecureTravOffer data={secureTravData} /> : ""}
          </React.Fragment>
        }
        rightComp={
          <LandingPageRightWrapper>
            {upcomingTripsV2 && (
              <DomesticTrip
                title={upcomingTripsV2?.title}
                trips={upcomingTripsV2?.trips}
              ></DomesticTrip>
            )}
            <TravellingTo
              travelSearchBanner={travelSearchBanner}
              travellingToSection={travellingTo}
              upcomingTrip={upcomingTrip}
              calendarDatesLimit={calendarDatesLimit}
              nextPageRoute={nextPageRoute}
              errorFields={errorFields}
              countryCodes={data.countryCode}
              setLoginModal={setActiveModal}
            />

            {device != "lg" && <SecureTravOffer data={secureTravData} />}
          </LandingPageRightWrapper>
        }
        bottomComp={
          <InsuranceBottomComp bottomCompData={data} footerInfo={footer} />
        }
      ></DesktopLayout>
    </>
  );
};

export default InsuranceLanding;
